<template>
  <a-card nopad class="flight-details-card">
    <div class="booking-title flight-details-title d-flex justify-space-between align-center">
      <span>Flight Details</span>
      <div class="d-flex align-center flight-detail-actions">
        <g-button
          :disabled="isCancelled"
          xsmall
          icon="edit"
          label="Domestic"
          @onclick="openDialog('DOMESTIC')"
        />
        <g-button
          :disabled="isCancelled"
          xsmall
          icon="edit"
          label="International"
          @onclick="openDialog('INTERNATIONAL')"
        />
      </div>
    </div>
    <div class="flight-main-fields">
      <v-row class="px-1 caption flight-detail-row" dense no-gutters>
        <v-col class="py-0 flight-leg-label" align-self="center">Arrival</v-col>
        <v-col class="py-0">
          <div class="flight-fields">
            <div class="flight-field">
              <a-field :config="config.date" :datewall="datewall" :datewallEnd="datewallEnd" v-model="arrival_date" />
            </div>
            <div class="flight-field">
              <a-field :config="config.airport" v-model="arrival_airport" />
            </div>
            <div class="flight-field">
              <a-field :config="config.flight_num" v-model="arrival_flight_num" />
            </div>
            <div class="flight-field">
              <a-field :config="config.time" v-model="arrival_time" />
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row class="px-1 caption flight-detail-row" dense no-gutters>
        <v-col class="py-0 flight-leg-label" align-self="center">Departure</v-col>
        <v-col class="py-0">
          <div class="flight-fields">
            <div class="flight-field">
              <a-field :config="config.date" :datewall="departWall" :datewallEnd="datewallEnd" v-model="depart_date" />
            </div>
            <div class="flight-field">
              <a-field :config="config.airport" v-model="depart_airport" />
            </div>
            <div class="flight-field">
              <a-field :config="config.flight_num" v-model="depart_flight_num" />
            </div>
            <div class="flight-field">
              <a-field :config="config.time" v-model="depart_time" />
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row v-if="internationalFlightList.length" class="px-3 subtitle-2 flight-section-header">International</v-row>
    <div v-if="internationalFlightList.length" class="flight-main-fields">
      <FlightRow v-for="(f, index) in internationalFlightList" :key="index + 'international'" :flight="f" />
    </div>

    <v-row v-if="domesticFlightList.length" class="px-3 subtitle-2 flight-section-header">Domestic</v-row>
    <div v-if="domesticFlightList.length" class="flight-main-fields">
      <FlightRow v-for="(f, index) in domesticFlightList" :key="index + 'domestic'" :flight="f" />
    </div>

    <FlightDialog
      v-model="domesticDialog"
      flightType="DOMESTIC"
      :datewall="datewall"
      :datewallEnd="datewallEnd"
      :flightList="tempFlightList"
      @update="(v) => (flightList = v)"
    />

    <FlightDialog
      v-model="internationalDialog"
      flightType="INTERNATIONAL"
      :datewall="datewall"
      :datewallEnd="datewallEnd"
      :flightList="tempFlightList"
      @update="(v) => (flightList = v)"
    />
  </a-card>
</template>

<script>
import moment from "moment";
import { BookingFields } from "@/config/fields/bookings";
import FlightDialog from "./_FlightDialog";
import FlightRow from "./FlightRow";
import { isFlightEmpty } from "../flightUtils";

export default {
  props: {
    bookingId: String,
  },
  components: {
    FlightDialog,
    FlightRow,
  },
  data() {
    return {
      config: BookingFields.flight,

      domesticDialog: false,
      internationalDialog: false,
      tempFlightList: [],
    };
  },
  computed: {
    datewall() {
      const { from } = this.$store.getters["BookingStore/active"];
      return moment(from).subtract(1, "day").format("YYYY-MM-DD");
    },
    datewallEnd() {
      const { to } = this.$store.getters["BookingStore/active"];
      return moment(to).add(1, "day").format("YYYY-MM-DD");
    },
    departWall() {
      return this.arrival_date || this.datewall;
    },

    arrival_date: {
      get() {
        return this.getArrive("date");
      },
      set(newValue) {
        return this.setArrive("date", newValue);
      },
    },
    arrival_airport: {
      get() {
        return this.getArrive("airport");
      },
      set(newValue) {
        return this.setArrive("airport", newValue);
      },
    },
    arrival_flight_num: {
      get() {
        return this.getArrive("flight_num");
      },
      set(newValue) {
        return this.setArrive("flight_num", newValue);
      },
    },
    arrival_time: {
      get() {
        return this.getArrive("time");
      },
      set(newValue) {
        return this.setArrive("time", newValue);
      },
    },

    depart_date: {
      get() {
        return this.getDeparture("date");
      },
      set(newValue) {
        return this.setDeparture("date", newValue);
      },
    },
    depart_airport: {
      get() {
        return this.getDeparture("airport");
      },
      set(newValue) {
        return this.setDeparture("airport", newValue);
      },
    },
    depart_flight_num: {
      get() {
        return this.getDeparture("flight_num");
      },
      set(newValue) {
        return this.setDeparture("flight_num", newValue);
      },
    },
    depart_time: {
      get() {
        return this.getDeparture("time");
      },
      set(newValue) {
        return this.setDeparture("time", newValue);
      },
    },

    flightList: {
      get() {
        return this.$store.getters["BookingFlightStore/flight_list"];
      },
      set(newValue) {
        return this.set("flight_list", newValue);
      },
    },
    domesticFlightList() {
      return this.flightList.filter((item) => {
        const isDomestic = !item.flight_type || item.flight_type === "DOMESTIC";
        return isDomestic && !isFlightEmpty(item);
      });
    },
    internationalFlightList() {
      return this.flightList.filter((item) => {
        return item.flight_type === "INTERNATIONAL" && !isFlightEmpty(item);
      });
    },

    isCancelled() {
      return this.$store.getters["BookingStore/isCancelled"];
    },
  },
  methods: {
    getArrive(val) {
      return this.$store.getters["BookingFlightStore/arrival"][val];
    },
    setArrive(key, val) {
      return this.$store.dispatch("BookingFlightStore/update", { deep: "arrival", key, val });
    },

    getDeparture(val) {
      return this.$store.getters["BookingFlightStore/departure"][val];
    },
    setDeparture(key, val) {
      return this.$store.dispatch("BookingFlightStore/update", { deep: "departure", key, val });
    },

    set(key, val) {
      return this.$store.dispatch("BookingFlightStore/update", { key, val });
    },

    openDialog(flightType) {
      this.tempFlightList = JSON.parse(JSON.stringify(this.flightList));
      if (flightType === "DOMESTIC") this.domesticDialog = true;
      if (flightType === "INTERNATIONAL") this.internationalDialog = true;
    },
  },
  beforeDestroy() {
    if (this.isCancelled) return;
    this.$store.dispatch("BookingFlightStore/saveFlights", this.bookingId).catch((err) => this.$root.$error(err));
  },
};
</script>

<style lang="scss">
@import "../flightDetails.scss";
</style>
